// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
const WhatsAppButton = () => (
  <a href="https://wa.me/21656078078?text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%20%D8%AE%D8%B7%D9%88%D8%A9%D8%8C%20%D8%A3%D8%B1%D9%8A%D8%AF%20%D9%85%D8%B9%D9%84%D9%88%D9%85%D8%A7%D8%AA%20%D8%B9%D9%86%20%D8%A7%D9%84%D8%AA%D8%B7%D8%A8%D9%8A%D9%82" target="_blank" rel="noopener" aria-label="راسلنا على واتساب" className="kh-pop" style={{ position: "fixed", bottom: "24px", right: "24px", zIndex: "55", display: "inline-flex", alignItems: "center", gap: "10px", height: "56px", padding: "0 20px 0 16px", borderRadius: "999px", background: "#25D366", color: "#FFFFFF", fontWeight: "800", fontSize: "16px", textDecoration: "none", boxShadow: "0 6px 0 #128C4B, 0 14px 30px rgba(11,18,64,0.3)" }}>
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 20l1.300-3.900A8 8 0 1 1 8 19z" />
      <path d="M9.200 8.600c.300 2.600 2.600 5 5.200 5.400l1-1.200-1.800-.900-.700.700c-.900-.400-1.700-1.200-2.100-2.100l.700-.700-.900-1.800z" fill="#FFFFFF" strokeWidth="1" />
    </svg>
    <span>
      واتساب
    </span>
  </a>
);

export default WhatsAppButton;
